import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import { Layout } from "@/components/Layout";
import AppSplash from "@/components/AppSplash";
import ScrollToTop from "@/components/ScrollToTop";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Appointments from "@/pages/Appointments";
import Intake from "@/pages/Intake";
import Portal from "@/pages/Portal";
import ClientReports from "@/pages/ClientReports";
import Admin from "@/pages/Admin";
import LeadsTab from "@/pages/LeadsTab";
import TasksTab from "@/pages/TasksTab";
import SmsWorkflowsTab from "@/pages/SmsWorkflowsTab";
import EmailCampaignsTab from "@/pages/EmailCampaignsTab";
import ReferralsTab from "@/pages/ReferralsTab";
import Refer from "@/pages/Refer";
import RevenueDashboard from "@/pages/RevenueDashboard";
import ActivityTab from "@/pages/ActivityTab";
import Forgot from "@/pages/Forgot";
import Reset from "@/pages/Reset";
import BackOffice from "@/pages/BackOffice";
import Resources from "@/pages/Resources";
import Contact from "@/pages/Contact";
import Welcome from "@/pages/Welcome";
import { Privacy, Terms } from "@/pages/Legal";
import { LanguageProvider } from "@/lib/i18n";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <AppSplash />
          <Toaster richColors position="top-right" />
          <Routes>
          {/* QR welcome — no chrome */}
          <Route path="/welcome" element={<Welcome />} />

          {/* App with layout */}
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/about" element={<Layout><About /></Layout>} />
          <Route path="/services" element={<Layout><Services /></Layout>} />
          <Route path="/appointments" element={<Layout><Appointments /></Layout>} />
          <Route path="/intake" element={<Layout><Intake /></Layout>} />
          <Route path="/portal" element={<Layout><Portal /></Layout>} />
          <Route path="/portal/books" element={<Layout><ClientReports /></Layout>} />
          <Route path="/admin" element={<Layout><Admin /></Layout>} />
          <Route path="/admin/leads" element={<Layout><LeadsTab /></Layout>} />
          <Route path="/admin/tasks" element={<Layout><TasksTab /></Layout>} />
          <Route path="/admin/sms" element={<Layout><SmsWorkflowsTab /></Layout>} />
          <Route path="/admin/email" element={<Layout><EmailCampaignsTab /></Layout>} />
          <Route path="/admin/referrals" element={<Layout><ReferralsTab /></Layout>} />
          <Route path="/refer" element={<Refer />} />
          <Route path="/admin/revenue" element={<Layout><RevenueDashboard /></Layout>} />
          <Route path="/admin/activity" element={<Layout><ActivityTab /></Layout>} />
          <Route path="/portal/forgot" element={<Layout><Forgot /></Layout>} />
          <Route path="/portal/reset" element={<Layout><Reset /></Layout>} />
          <Route path="/back-office" element={<Layout><BackOffice /></Layout>} />
          <Route path="/bookkeeping" element={<Layout><BackOffice /></Layout>} />
          <Route path="/resources" element={<Layout><Resources /></Layout>} />
          <Route path="/contact" element={<Layout><Contact /></Layout>} />
          <Route path="/privacy" element={<Layout><Privacy /></Layout>} />
          <Route path="/terms" element={<Layout><Terms /></Layout>} />
          <Route path="*" element={<Layout><Home /></Layout>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
